import React from 'react';
import ReactDOM from 'react-dom';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import '../sass/app_omisalj.scss';
import registerServiceWorker from './registerServiceWorker';
import Booking from './Booking';
import ReservationForm from './ReservationForm';

const bookingEl = document.getElementById('root')
const reservationsEl = document.getElementById('reservations')

bookingEl && ReactDOM.render(<Booking caretColor='#35A8E0' closeCaretColor='#F8B133' />, bookingEl);
reservationsEl && ReactDOM.render(<ReservationForm caretColor='#35A8E0' />, reservationsEl);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/js/index_omisalj.js